export default __webpack_public_path__ + "static/media/eventicon.3e6c6403.png";